import React, { useState , useEffect} from 'react';
import '../CSS/EvaBanquetHall.css';
import venueImage from '../assets/ContactHeaderImg.jpeg';
import { FaUtensils, FaWifi, FaParking, FaUsers, FaMusic, FaCamera, FaStar, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import Contactbar from '../Components/ContactBar';

import eva1 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.41 PM (1).jpeg';
import eva2 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.43 PM (2).jpeg';
import eva3 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.44 PM (1).jpeg';
import eva4 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.44 PM.jpeg';
import eva5 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-24 at 7.13.52 PM (14).jpeg';
import eva6 from '../assets/LIBRA EVENTS/WhatsApp Image 2024-01-26 at 7.51.18 PM (4).jpeg';
import eva7 from '../assets/LIBRA EVENTS/KSH_0837.jpg';
import eva8 from '../assets/LIBRA EVENTS/KSH_0929.jpg';
import eva9 from '../assets/LIBRA EVENTS/KSH_7687.jpg';

const EvaBanquetHall = () => {

  useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top on page load
  }, []);

    const [selectedImage, setSelectedImage] = useState(null);
const openModal = (img) => setSelectedImage(img);
const closeModal = () => setSelectedImage(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
 
  const handleSubmit = (e) => {
    e.preventDefault();
 
    const message = `*Venue Booking Request*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Message:* ${formData.message}`;
 
    const phoneNumber = '919909254684'; // 🔁 Replace with your WhatsApp number (with country code)
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
 
    window.open(url, '_blank');
 
    setShowModal(false); // Close modal
    setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
  };
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="Eva-hero" style={{ backgroundImage: `url(${venueImage})` }}>
        <div className="Eva-hero-overlay">
          <h1>EVA BANQUET HALL</h1>
          <p>Premium Venue for Unforgettable Celebrations</p>
        </div>
      </section>

      {/* About Section */}
      <section className="Eva-content">
        <div className="Eva-details">
          <h2>About the Venue</h2>
          <p>
Welcome to Eva Banquet Hall, where timeless elegance meets contemporary charm to create truly unforgettable celebrations. Now proudly managed by Libra Events & Decorations, Eva Banquet Hall continues its legacy as a premier destination for weddings, receptions, corporate gatherings, and all your special occasions in Vadodara.
  <br/><br/>
Our venue is thoughtfully designed to offer an ambiance of luxurious comfort. From the moment you step inside, you'll discover spacious interiors graced with exquisite décor and equipped with advanced lighting and sound systems, all meticulously curated to set the perfect mood for your event. Situated conveniently in the heart of the city, Eva Banquet Hall provides easy accessibility for all your guests, ensuring a seamless experience from the first consultation to the final farewell.
  <br/><br/>
At Eva Banquet Hall, we understand that every detail matters. Our team of dedicated event professionals, now backed by the extensive expertise of Libra Events & Decorations, is committed to bringing your vision to life. We work tirelessly to tailor every aspect of your event, whether it's a grand, opulent affair or a more intimate gathering, ensuring our versatile space perfectly aligns with your unique needs.
  <br/><br/>
Beyond the stunning setting, we offer exceptional catering services with a diverse range of culinary delights, convenient parking facilities, and a warm, inviting atmosphere that makes every guest feel cherished. Our goal is to provide a stress-free planning experience, allowing you to fully immerse yourself in the joy of your special moments.
  <br/><br/>
Discover the renewed charm and unwavering commitment to excellence at Eva Banquet Hall. We invite you to visit us and experience firsthand how we can transform your dreams into spectacular, lasting memories.
</p>
          

          <h3>Key Features</h3>
          <div className="Eva-features">
            <div className="Eva-feature-item"><FaUsers className="icon" /> 1000 Guest Capacity</div>
            <div className="Eva-feature-item"><FaParking className="icon" /> Valet Parking</div>
            <div className="Eva-feature-item"><FaWifi className="icon" /> High-Speed WiFi</div>
            <div className="Eva-feature-item"><FaUtensils className="icon" /> Premium Catering</div>
            <div className="Eva-feature-item"><FaMusic className="icon" /> Sound System</div>
            <div className="Eva-feature-item"><FaCamera className="icon" /> Photo Zones</div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
<section className="Eva-gallery">
  <h2>Venue Gallery</h2>
  <div className="gallery-grid">
    {[
      eva1,
      eva2,
      eva3,
      eva4,
      eva5,
      eva6,
      eva7,
      eva8,
      eva9
    ].map((img, index) => (
      <div key={index} className="gallery-item">
        <img src={img} alt={`Gallery ${index + 1}`} onClick={() => openModal(img)} />
      </div>
    ))}
  </div>

  {/* Modal */}
  {selectedImage && (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={selectedImage} alt="Zoomed" />
        <span className="modal-close" onClick={closeModal}>&times;</span>
      </div>
    </div>
  )}
</section>

      {/* Event Types Section */}
      <section className="Eva-events">
        <h2>Perfect For All Occasions</h2>
        <div className="event-types">
          <div><FaCalendarAlt /> Weddings</div>
          <div><FaCalendarAlt /> Engagements</div>
          <div><FaCalendarAlt /> Corporate Seminars</div>
          <div><FaCalendarAlt /> Birthday Parties</div>
          <div><FaCalendarAlt /> Anniversary Celebrations</div>
        </div>
      </section>

      {/* Amenities Section */}
      <section className="Eva-amenities">
        <h2>Amenities</h2>
        <ul className="amenities-list">
            <li>Air-conditioned Hall</li>
            <li>Standard Parking</li>
            <li>High-Speed Wi-Fi</li>
            <li>Stage and Lighting</li>
            <li>On-Site Catering</li>
            <li>Changing Rooms</li>
            <li>Backup Power Supply</li>
            <li>Audio Visual Equipment</li>
            <li>Dedicated Event Manager</li>
            <li>Security Staff</li>
            <li>Luxury Washrooms</li>
            <li>Photobooth Area</li>
        </ul>
    </section>


      {/* Why Choose Us */}
      <section className="Eva-why-choose">
        <h2>Why Choose Eva Banquet Hall ?</h2>
        <p>
           With our blend of luxury, service, and technology, we offer a truly premium experience. Our team ensures that every event is stress-free,
  beautifully executed, and memorable for both hosts and guests.
  <br/><br/>
  From personalized décor themes to gourmet catering, we tailor every detail to match your vision and style. Our staff is trained to deliver impeccable hospitality,
  making sure your guests feel welcomed and cared for throughout the event.
  <br/><br/>
  With ample parking space, flexible seating arrangements, and cutting-edge facilities, we go above and beyond to create an unforgettable experience
  that exceeds expectations.
        </p>
        <div className="reasons">
          <div><FaStar /> Trusted by Thousands of Clients</div>
          <div><FaStar /> Centrally Located</div>
          <div><FaStar /> Highly Rated Service</div>
          <div><FaStar /> Tailored Packages Available</div>
        </div>
      </section>

      {/* Map/Location (optional image placeholder) */}
      <section className="Eva-map">
        <h2>Our Location</h2>
        <div className="map-placeholder">
          <FaMapMarkerAlt className="map-icon" />
          <p> Basement, 1, Eva Mall Rd,
      near Saraswati Complex, <br/>
      Patidar Crossing, Manjalpur, 
      Vadodara, Gujarat 390011</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.130874232507!2d73.18579307427751!3d22.27303174388519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc5dc2bde1cfd%3A0xa435e654a2557c24!2sEva%20Banquet!5e0!3m2!1sen!2sin!4v1748431747093!5m2!1sen!2sin"width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"
                ></iframe>
        </div>
      </section>

      {/* Booking CTA */}
<div className="Eva-cta-wrapper">
  <section className="Eva-booking-cta">
    <h2>Ready to Book Your Event ?</h2>
    <p>Make your celebration unforgettable at Eva Banquet Hall. Contact us now to check availability and receive a customized quote for your special occasion.</p>
    <div className="cta-buttons">
      <button className="book-now" onClick={() => setShowModal(true)}>Book Now</button>
      <a href="/venues" className="contact">Back to Venues</a>
    </div>
  </section>
</div>

{/* Modal Section */}
      {showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <h3>Book Now</h3>
      <form className="modal-form" onSubmit={(e) => handleSubmit(e)}>
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
        />
        <input
          type="tel"
          placeholder="Your Phone"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
        />
        <textarea
          placeholder="Message / Special Requests"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        ></textarea>
        <div className="modal-actions">
          <button type="submit" className="submit-btn">Send</button>
          <button type="button" className="close-btn" onClick={() => setShowModal(false)}>Close</button>
        </div>
      </form>
    </div>
  </div>
)}

<Contactbar/>
      <Footer />
    </>
  );
};

export default EvaBanquetHall;
